import { appendDataToListTable, renderListError } from '../crud/shared.js';
import { PageTitle } from '../../components.js';
import { Page } from '../base.js';

class SupportListRow {
  static props = ['href', 'subject', 'status', 'priority', 'createdAt', 'createdBy'];
  static timl = `
    td
      a[href="{{ Props.href }}"] {{ Props.subject }}
    td.pr-4 {{ Props.status }}
    td.pr-4 {{ Props.priority }}
    td.table-col-100.pr-4[style="white-space:nowrap;"] {{ Props.createdAt }}
    td.table-col-100 {{ Props.createdBy }}
  `;
}

export class SupportList extends Page {
  static timlComponents = {
    PageTitle
  };

  static timl = `
    a.list-view-add-button.create-button[href="/support/create"] New ticket
    <PageTitle title="Support">
    table.resource-table[data-empty-title="No support tickets yet" data-empty-description="Create a ticket and we’ll help you solve the issue." data-empty-action="New ticket" data-empty-href="/support/create"]
      thead
        th Subject
        th.pr-4 Status
        th.pr-4 Priority
        th.table-col-100.pr-4 Created At
        th.table-col-100 Created By
      tbody#support-list-rows.fade
  `;

  static javascript() {
    API.get(API.resourceUrl('support'))
      .then(response => {
        appendDataToListTable('#support-list-rows', response.data, SupportListRow, this.mapItemToRowData);
      })
      .catch(error => renderListError('#support-list-rows', error, 'Support'));
  }

  static mapItemToRowData(item) {
    return {
      href: `${location.href}/${item.id}#${item.subject}`,
      subject: item.subject || '',
      status: item.status || '',
      priority: item.priority || '',
      createdAt: Util.formatDate(item.createdAt) || '',
      createdBy: item.createdBy || ''
    };
  }
}
